import * as MuiButton from '@mui/material/Button'
import React, { ForwardedRef } from 'react'

export type ButtonProps = MuiButton.ButtonProps

export const Button = React.forwardRef(
  (
    { children, ...props }: ButtonProps,
    ref?: ForwardedRef<HTMLButtonElement>,
  ) => (
    <MuiButton.default ref={ref} {...props}>
      {children}
    </MuiButton.default>
  ),
)
